import { makeStyles, Theme } from '@material-ui/core/styles'

export const useClasses = makeStyles((theme: Theme) => ({
  toolbarContainer: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5),
      paddingLeft: theme.spacing(10),
    },
  },
  offerFieldWrapper: {
    [theme.breakpoints.up('sm')]: {
      boxSizing: 'content-box',
      maxWidth: 300,
    },
  },
  dateFieldWrapper: {
    [theme.breakpoints.up('sm')]: {
      boxSizing: 'content-box',
      maxWidth: 200,
    },
  },
  plateNumberFieldWrapper: {
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      boxSizing: 'content-box',
      maxWidth: 200,
    },
  },
  listTitle: {
    marginBottom: 20,
  },
  refreshButton: {
    marginLeft: 8,
    marginTop: -3,
  },
}))
